(() => {
  if (window.__toaHomepageFaqAioV1) return;
  window.__toaHomepageFaqAioV1 = true;

  const ROOT_ID = "toa-homepage-faq-aio";
  const HOME_PATHS = new Set(["", "/", "/de", "/de/", "/en", "/en/"]);

  const faqs = [
    {
      question: "Kann ich bei Taste of Asia asiatische Lebensmittel online kaufen?",
      answer: "Ja. Im Online-Shop findest du asiatische Lebensmittel wie Ramen, Reis, Nudeln, Saucen, Gew\u00fcrze, Snacks, S\u00fc\u00dfwaren und Getr\u00e4nke."
    },
    {
      question: "Gibt es Taste of Asia auch als Laden in Konstanz?",
      answer: "Ja. Unser Markt ist in der St.-Gebhard-Stra\u00dfe 17-19 in Konstanz. Dort findest du viele weitere Artikel und bekommst direkt Beratung im Laden."
    },
    {
      question: "Welche L\u00e4nder und K\u00fcchen finde ich im Sortiment?",
      answer: "Besonders stark vertreten sind Korea, Japan, Thailand, China, Indien und weitere asiatische K\u00fcchen mit passenden Basics, Saucen, Gew\u00fcrzen, Snacks und Getr\u00e4nken."
    },
    {
      question: "Gibt es Rezepte mit passenden Produkten?",
      answer: "Ja. Im Rezeptbereich findest du Gerichte nach L\u00e4ndern sortiert und passende Zutaten direkt aus dem Shop. So kannst du Rezeptideen entdecken und wichtige Produkte direkt mitbestellen."
    },
    {
      question: "Was bedeutet Neu im Shop?",
      answer: "Im Bereich Neu im Shop zeigen wir Produkte, die frisch ins Sortiment gekommen sind. Die Auswahl wird regelm\u00e4\u00dfig gepflegt und durch neue Artikel ersetzt."
    },
    {
      question: "Wie schnell liefert Taste of Asia?",
      answer: "Viele Bestellungen sind in der Regel innerhalb von 1 bis 3 Werktagen bei dir. Die genaue Lieferinformation siehst du im Shop, Warenkorb und Checkout."
    },
    {
      question: "Ab wann ist der Versand kostenlos?",
      answer: "Der Shop zeigt dir im Warenkorb den aktuellen Warenwert bis zum kostenlosen Versand. Pfand wird dabei nicht als Warenwert f\u00fcr den kostenlosen Versand eingerechnet."
    },
    {
      question: "Warum erw\u00e4hnt Taste of Asia Solarstrom?",
      answer: "Unsere gro\u00dffl\u00e4chige Solarfassade ist ein sichtbares Zeichen f\u00fcr lokalen Handel und mehr Verantwortung am Standort Konstanz."
    }
  ];

  const searchPages = [
    {
      title: "Asiatische Lebensmittel online kaufen",
      href: "/pages/asiatische-lebensmittel-online-kaufen"
    },
    {
      title: "Koreanische Lebensmittel",
      href: "/pages/koreanische-lebensmittel-online-kaufen"
    },
    {
      title: "Koreanische Snacks",
      href: "/pages/koreanische-snacks-online-kaufen"
    },
    {
      title: "Kimchi, Gochujang & Miso",
      href: "/pages/kimchi-gochujang-miso-kaufen"
    },
    {
      title: "Japanische Lebensmittel",
      href: "/pages/japanische-lebensmittel-online-kaufen"
    },
    {
      title: "Japanische Snacks",
      href: "/pages/japanische-snacks-online-kaufen"
    },
    {
      title: "Mochi",
      href: "/pages/mochi-online-kaufen"
    },
    {
      title: "Ramen",
      href: "/pages/ramen-online-kaufen"
    },
    {
      title: "Asia Nudeln",
      href: "/pages/asia-nudeln-online-kaufen"
    },
    {
      title: "Thai Curry Zutaten",
      href: "/pages/thai-curry-zutaten-kaufen"
    },
    {
      title: "Thai Lebensmittel",
      href: "/pages/thai-lebensmittel-online-kaufen"
    },
    {
      title: "Bubble Tea Zutaten",
      href: "/pages/bubble-tea-zutaten-kaufen"
    },
    {
      title: "Indische Lebensmittel",
      href: "/pages/indische-lebensmittel-online-kaufen"
    },
    {
      title: "Saucen, Reis, Nudeln & Gew\u00fcrze",
      href: "/pages/sojasauce-reis-nudeln-gewuerze"
    }
  ];

  const css = `
    #${ROOT_ID},
    #${ROOT_ID} * {
      box-sizing: border-box;
    }

    #${ROOT_ID} {
      width: 100vw;
      max-width: 100vw;
      margin-left: calc(50% - 50vw);
      margin-right: calc(50% - 50vw);
      padding: clamp(48px, 5vw, 78px) max(18px, calc((100vw - 1180px) / 2));
      border-top: 1px solid rgba(216, 173, 87, .26);
      background:
        radial-gradient(circle at 88% 8%, rgba(216, 173, 87, .13), rgba(216, 173, 87, 0) 34%),
        linear-gradient(180deg, #fffaf0 0%, #f5efe4 100%);
      color: #12351f;
      font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      overflow: hidden;
    }

    .toa-homepage-faq-aio__inner {
      display: grid;
      grid-template-columns: minmax(260px, .78fr) minmax(0, 1.22fr);
      gap: clamp(28px, 4vw, 58px);
      align-items: start;
    }

    .toa-homepage-faq-aio__kicker {
      display: inline-flex;
      width: fit-content;
      min-height: 32px;
      align-items: center;
      padding: 7px 12px;
      border: 1px solid rgba(184, 58, 49, .28);
      border-radius: 999px;
      background: rgba(255, 255, 255, .56);
      color: #b83a31;
      font-size: 12px;
      font-weight: 950;
      letter-spacing: .08em;
      line-height: 1;
      text-transform: uppercase;
    }

    .toa-homepage-faq-aio__title {
      max-width: 520px;
      margin: 16px 0 0;
      color: #0b3826;
      font-family: Georgia, "Times New Roman", serif;
      font-size: clamp(36px, 4.3vw, 62px);
      font-weight: 500;
      line-height: 1.02;
      letter-spacing: 0;
    }

    .toa-homepage-faq-aio__intro {
      max-width: 520px;
      margin: 16px 0 0;
      color: #506052;
      font-size: clamp(15px, 1.2vw, 17px);
      line-height: 1.55;
    }

    .toa-homepage-faq-aio__links {
      display: flex;
      flex-wrap: wrap;
      gap: 3px 8px;
      align-items: baseline;
      max-width: 620px;
      margin: 18px 0 0;
      color: rgba(18, 53, 31, .68);
      font-size: 13px;
      line-height: 1.55;
    }

    .toa-homepage-faq-aio__links-label {
      color: rgba(18, 53, 31, .74);
      font-weight: 850;
      white-space: nowrap;
    }

    .toa-homepage-faq-aio__link {
      display: inline;
      padding: 0;
      border: 0;
      border-bottom: 1px solid rgba(184, 58, 49, .22);
      border-radius: 0;
      background: transparent;
      color: rgba(18, 53, 31, .82);
      font-size: 13px;
      font-weight: 750;
      line-height: inherit;
      text-decoration: none;
      box-shadow: none;
    }

    .toa-homepage-faq-aio__separator {
      color: rgba(18, 53, 31, .38);
    }

    .toa-homepage-faq-aio__link:hover,
    .toa-homepage-faq-aio__link:focus-visible {
      border-bottom-color: rgba(184, 58, 49, .68);
      color: #b83a31;
    }

    .toa-homepage-faq-aio__list {
      display: grid;
      gap: 10px;
      min-width: 0;
    }

    .toa-homepage-faq-aio__item {
      border: 1px solid rgba(18, 53, 31, .13);
      border-radius: 8px;
      background: rgba(255, 255, 255, .62);
      box-shadow: 0 14px 34px rgba(38, 28, 12, .06);
      overflow: hidden;
    }

    .toa-homepage-faq-aio__item summary {
      min-height: 58px;
      display: grid;
      grid-template-columns: minmax(0, 1fr) 34px;
      align-items: center;
      gap: 14px;
      padding: 17px 18px;
      color: #12351f;
      cursor: pointer;
      font-size: clamp(15px, 1.08vw, 18px);
      font-weight: 900;
      line-height: 1.25;
      list-style: none;
    }

    .toa-homepage-faq-aio__item summary::-webkit-details-marker {
      display: none;
    }

    .toa-homepage-faq-aio__icon {
      width: 34px;
      height: 34px;
      display: grid;
      place-items: center;
      border-radius: 999px;
      background: #123b21;
      color: #fffaf0;
      font-size: 20px;
      font-weight: 700;
      line-height: 1;
      transition: transform .18s ease, background-color .18s ease;
    }

    .toa-homepage-faq-aio__item[open] .toa-homepage-faq-aio__icon {
      background: #c43a31;
      transform: rotate(45deg);
    }

    .toa-homepage-faq-aio__answer {
      margin: 0;
      padding: 0 18px 19px;
      color: #445449;
      font-size: clamp(14px, 1vw, 16px);
      line-height: 1.58;
    }

    @media (max-width: 860px) {
      #${ROOT_ID} {
        padding: 42px 18px 46px;
      }

      .toa-homepage-faq-aio__inner {
        grid-template-columns: 1fr;
        gap: 24px;
      }

      .toa-homepage-faq-aio__title,
      .toa-homepage-faq-aio__intro,
      .toa-homepage-faq-aio__links {
        max-width: none;
      }
    }

    @media (max-width: 520px) {
      #${ROOT_ID} {
        padding: 38px 14px 96px;
      }

      .toa-homepage-faq-aio__title {
        font-size: 36px;
      }

      .toa-homepage-faq-aio__item summary {
        grid-template-columns: minmax(0, 1fr) 30px;
        min-height: 54px;
        padding: 15px 14px;
      }

      .toa-homepage-faq-aio__icon {
        width: 30px;
        height: 30px;
        font-size: 18px;
      }

      .toa-homepage-faq-aio__answer {
        padding: 0 14px 16px;
      }
    }
  `;

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, char => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }[char]));
  }

  function isHomepage() {
    const path = String(window.location.pathname || "/").replace(/\/+$/, "");
    return document.body.classList.contains("template-index") || HOME_PATHS.has(path) || HOME_PATHS.has(path + "/");
  }

  function injectStyle() {
    if (document.getElementById(ROOT_ID + "-style")) return;
    const style = document.createElement("style");
    style.id = ROOT_ID + "-style";
    style.textContent = css;
    document.head.appendChild(style);
  }

  function faqHtml() {
    return faqs.map((faq, index) => `
      <details class="toa-homepage-faq-aio__item"${index === 0 ? " open" : ""}>
        <summary>
          <span>${escapeHtml(faq.question)}</span>
          <span class="toa-homepage-faq-aio__icon" aria-hidden="true">+</span>
        </summary>
        <p class="toa-homepage-faq-aio__answer">${escapeHtml(faq.answer)}</p>
      </details>
    `).join("");
  }

  function searchPagesHtml() {
    return searchPages.map((page, index) => `
      ${index ? '<span class="toa-homepage-faq-aio__separator" aria-hidden="true">\u00b7</span>' : ""}
      <a class="toa-homepage-faq-aio__link" href="${escapeHtml(page.href)}">${escapeHtml(page.title)}</a>
    `).join("");
  }

  function createSection() {
    const section = document.createElement("section");
    section.id = ROOT_ID;
    section.setAttribute("aria-labelledby", ROOT_ID + "-title");
    section.innerHTML = `
      <div class="toa-homepage-faq-aio__inner">
        <header class="toa-homepage-faq-aio__header">
          <span class="toa-homepage-faq-aio__kicker">Gut zu wissen</span>
          <h2 class="toa-homepage-faq-aio__title" id="${ROOT_ID}-title">H\u00e4ufige Fragen</h2>
          <p class="toa-homepage-faq-aio__intro">Kurze Antworten zu Sortiment, Laden, Versand, Rezepten und Nachhaltigkeit bei Taste of Asia Konstanz.</p>
          <nav class="toa-homepage-faq-aio__links" aria-label="Beliebte Suchseiten">
            <span class="toa-homepage-faq-aio__links-label">Beliebte Suchseiten:</span>
            ${searchPagesHtml()}
          </nav>
        </header>
        <div class="toa-homepage-faq-aio__list">
          ${faqHtml()}
        </div>
      </div>
    `;
    return section;
  }

  function insertSection(section) {
    const footer = document.querySelector("footer, .site-footer, #shopify-section-footer, [id^='shopify-section-sections--'][id$='__footer']");
    if (footer && footer.parentNode) {
      footer.parentNode.insertBefore(section, footer);
      return;
    }
    const main = document.querySelector("main#content, main, #MainContent, .main-content") || document.body;
    main.appendChild(section);
  }

  function boot() {
    if (!document.body || !isHomepage() || document.getElementById(ROOT_ID)) return;
    injectStyle();
    insertSection(createSection());
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
  else boot();
  window.addEventListener("pageshow", boot);
})();
